import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-fyi',
  templateUrl: './fyi.component.html',
  styles: [],
  encapsulation: ViewEncapsulation.None
})
export class FyiComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/dev/github/ng4wedding/wedding/src/app/pages/fyi/fyi.component.ts